import * as yup from "yup";

export const CARE_MANAGEMENT_INITIAL_VALUES = {
  content: {
    care_resources: {
      do_others_help_with_life_activities: "",
      elaborate_assistance_needed: "",
      help_to_improve_life: "",
      life_improving_goals: "",
    },
    conclusion: {
      summary: "",
      tier_1: {
        emergency_food_needs: "",
        health_emergency: "",
        homelessness_or_housing_insecurity: "",
        other: "",
        risk_of_violence: "",
        shelter: "",
      },
      tier_2: {
        no_access_food: "",
        no_access_medical: "",
        other: "",
        recent_admission_or_ed: "",
        urgent_health_conditions: "",
      },
      tier_3: {
        adls: "",
        chronic_condition: "",
        educational: "",
        employment: "",
        financial: "",
        home_goods: "",
        legal_problems: "",
        leisure: "",
        limitations: "",
        other: "",
        relationships_social: "",
      },
    },
    cultural_impact: {
      family_cultural_views: "",
      health_care_approach_discouraged: "",
    },
    review: {
      can_be_assisted_with_life_planning_activities: "",
      difficulties_navigating_health_system: "",
      evaluation: "",
      understanding_of_diagnosis: "",
    },
  },
  is_billable: false,
  is_processed: false,
  note_type: "Care Management",
  patient_first_name: "",
  patient_id: "",
  patient_last_name: "",
  provider_cp_credentials: "",
  provider_id: "",
  provider_name: "",
  provider_type: "",
  signature: "",
  signature_date: "",
  title: "Care Management Assessment",
  version: 7,
};

export const CAN_BE_ASSISTED_WITH_LIFE_PLANNING_ACTIVITIES_OPTIONS = [
  {
    label: "Yes – Patient provided with education",
    value: "Yes - Patient provided with education",
  },
  {
    label: "No – Patient declined education",
    value: "No - Patient declined education",
  },
  {
    label: "Not appropriate",
    value: "Not appropriate",
  },
];

const CAN_BE_ASSISTED_WITH_LIFE_PLANNING_ACTIVITIES_ANSWERS =
  CAN_BE_ASSISTED_WITH_LIFE_PLANNING_ACTIVITIES_OPTIONS.map((item) => item.value);

export const HELP_TO_IMPROVE_LIFE_OPTIONS = [
  {
    label: "Patient is independent",
    value: "Patient is independent",
  },
  {
    label: "Needs minor help",
    value: "Needs minor help",
  },
  {
    label: "Needs some help",
    value: "Needs some help",
  },
  {
    label: "Needs significant help",
    value: "Needs significant help",
  },
];

const HELP_TO_IMPROVE_LIFE_ANSWERS = HELP_TO_IMPROVE_LIFE_OPTIONS.map((item) => item.value);

export const DO_OTHERS_HELP_WITH_LIFE_ACTIVITIES_OPTIONS = [
  {
    label: "Not applicable",
    value: "Not applicable",
  },
  {
    label: "Unclear",
    value: "Unclear",
  },
  {
    label: "Do not assist",
    value: "Do not assist",
  },
  {
    label: "Unlikely to assist",
    value: "Unlikely to assist",
  },
  {
    label: "Assist",
    value: "Assist",
  },
];

const DO_OTHERS_HELP_WITH_LIFE_ACTIVITIES_ANSWERS = DO_OTHERS_HELP_WITH_LIFE_ACTIVITIES_OPTIONS.map(
  (item) => item.value,
);

export const CONCLUSION_RATINGS = ["Not at all", "Very little", "Somewhat", "Much", "Very much"];

export const CARE_MANAGEMENT_VALIDATION = yup.object().shape({
  content: yup.object().shape({
    care_resources: yup.object().shape({
      do_others_help_with_life_activities: yup
        .string()
        .required("Question is required")
        .nullable()
        .oneOf(
          DO_OTHERS_HELP_WITH_LIFE_ACTIVITIES_ANSWERS,
          `The answer must match one of: ${HELP_TO_IMPROVE_LIFE_ANSWERS.join(", ")}`,
        ),
      elaborate_assistance_needed: yup.string().required("Question is required").nullable(),
      help_to_improve_life: yup
        .string()
        .required("Question is required")
        .nullable()
        .oneOf(
          HELP_TO_IMPROVE_LIFE_ANSWERS,
          `The answer must match one of: ${HELP_TO_IMPROVE_LIFE_ANSWERS.join(", ")}`,
        ),
      life_improving_goals: yup.string().required("Question is required").nullable(),
    }),
    conclusion: yup.object().shape({
      summary: yup.string().required("Question is required").nullable(),
      tier_1: yup.object().shape({
        emergency_food_needs: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        health_emergency: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        homelessness_or_housing_insecurity: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        other: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        risk_of_violence: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        shelter: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
      }),
      tier_2: yup.object().shape({
        no_access_food: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        no_access_medical: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        other: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        recent_admission_or_ed: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        urgent_health_conditions: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
      }),
      tier_3: yup.object().shape({
        adls: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        chronic_condition: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        educational: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        employment: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        financial: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        home_goods: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        legal_problems: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        leisure: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        limitations: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        other: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
        relationships_social: yup
          .string()
          .required("Question is required")
          .nullable()
          .oneOf(
            CONCLUSION_RATINGS,
            `The answer must match one of: ${CONCLUSION_RATINGS.join(", ")}`,
          ),
      }),
    }),
    cultural_impact: yup.object().shape({
      family_cultural_views: yup.string().required("Question is required").nullable(),
      health_care_approach_discouraged: yup.string().required("Question is required").nullable(),
    }),
    review: yup.object().shape({
      can_be_assisted_with_life_planning_activities: yup
        .string()
        .required("Question is required")
        .nullable()
        .oneOf(
          CAN_BE_ASSISTED_WITH_LIFE_PLANNING_ACTIVITIES_ANSWERS,
          `The answer must match one of: ${CAN_BE_ASSISTED_WITH_LIFE_PLANNING_ACTIVITIES_ANSWERS.join(
            ", ",
          )}`,
        ),
      difficulties_navigating_health_system: yup
        .string()
        .required("Question is required")
        .nullable(),
      evaluation: yup.string().required("Question is required").nullable(),
      understanding_of_diagnosis: yup.string().required("Question is required").nullable(),
    }),
  }),
  signature: yup.string().required("Question is required"),
});
